<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="../../../../assets/img/Recurso 42@72x.png" alt="Silva" width="100">
    </a>
  </div>
</div>

<div class="header-container">
  <div class="d-none d-lg-block">
    <span class="fsize-22 c-009f79 padding-lr-5">{{smallText}}</span>
    <span class="fsize-26 fweight-bold c-009f79 padding-lr-5">{{bigText}}</span>
  </div>
</div>
<!--
-->